import React, { useEffect, useState, forwardRef } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png';
import conalotLogo from '../../images/conalot.png';
import superGanaLogo from '../../images/super-gana.png';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';

const SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/suertesolidaria?igsh=OHoxa29rZjdscGxz&utm_source=qr',
    tiktok: 'https://vt.tiktok.com/ZSCvQJ9uk/',
};

const Footer = forwardRef(function Footer({ className = '' }, ref) {
    const [contacto, setContacto] = useState({});

    useEffect(() => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setContacto(data.contacto?.reverse()[0] || {});
            })
            .catch(() => {});
    }, []);

    const ubicacion = contacto.direccion || 'Valencia, Carabobo';
    const bottomParts = [
        'Suerte Solidaria',
        ubicacion,
        contacto.email,
        contacto.telefono,
    ].filter(Boolean);

    return (
        <footer ref={ref} className={`main-footer ${className}`.trim()}>
            <div className="footer-top">
                <div className="footer-column footer-left">
                    <nav aria-label="Información de la empresa">
                        <ul className="footer-links">
                            <li>
                                <span className="footer-link-item">Suerte Solidaria.</span>
                            </li>
                            <li>
                                <span className="footer-link-item">{ubicacion}</span>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className="footer-column footer-center">
                    <Link to="/" className="footer-brand">
                        <img src={logo} alt="Suerte Solidaria" className="footer-logo" />
                        <span className="footer-brand-name">SUERTE SOLIDARIA</span>
                    </Link>

                    <div className="footer-divider" aria-hidden="true">
                        <span className="footer-divider-line" />
                    </div>

                    <p className="footer-section-title">Síguenos</p>

                    <div className="footer-socials">
                        <a
                            href={SOCIAL_LINKS.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-social-link"
                            aria-label="Instagram"
                        >
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a
                            href={SOCIAL_LINKS.tiktok}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-social-link"
                            aria-label="TikTok"
                        >
                            <FontAwesomeIcon icon={faTiktok} />
                        </a>
                    </div>
                </div>

                <div className="footer-column footer-right">
                    <p className="footer-section-title footer-section-title-right">Avalado por</p>

                    <div className="footer-endorsements">
                        <div className="endorsement-logos">
                            <div className="endorsement-logo">
                                <img src={logo} alt="Manifiéstalo Ya" />
                            </div>
                            <div className="endorsement-logo">
                                <img src={superGanaLogo} alt="Super Gana" />
                            </div>
                            <div className="endorsement-logo">
                                <img src={conalotLogo} alt="CONALOT" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>{bottomParts.join(' | ')}</p>
            </div>
        </footer>
    );
});

export default Footer;
